import { LabelType } from 'generated/graphql';
import { useParams } from 'react-router-dom';
import { EntityLabel } from 'v2/core/entities/labels';
import { UUID } from 'v2/core/entities/uuid';
import useGetLabel from 'v2/core/repository/edge-server/labels/useGetLabel';
import { QueryStatus } from 'v2/core/repository/edge-server/types';

export const useGetEntityLabel = (
  id?: UUID,
):
  | [QueryStatus.SUCCESS_COMPLETED, EntityLabel]
  | [Exclude<QueryStatus, QueryStatus.SUCCESS_COMPLETED>, undefined] => {
  const { id: idFromParam } = useParams<{
    id: string;
  }>();
  const entityID = id ?? idFromParam;

  const { data, status } = useGetLabel(entityID);

  if (status !== QueryStatus.SUCCESS_COMPLETED) {
    return [status, undefined];
  }
  if (!data) {
    return [QueryStatus.IN_PROGRESS, undefined];
  }

  if (data?.type && data.type !== LabelType.Aspect) {
    console.error('entity id returned non-entity type label', {
      entityID,
      label: data,
    });
    return [QueryStatus.ERROR_COMPLETED, undefined];
  }

  return [status, data];
};
